import { useState } from 'react';

import SentimentWorkFlow from '../../../../assets/directory/sentiment_work_flow.png';
import { defaultSentimentPeriod } from '../../../../data/directory/topics/topicsSentimentAnalysis';

import PeriodFilters from '../PeriodFilters';
import SentimentTags from '../SentimentTags';
import DcscPoweredByWithTooltip from '../../../Shared/DcscPoweredByWithTooltip';

import Styles from './styles.module.scss';

const SectorsType = () => {
  const [activePeriod, setActivePeriod] = useState(defaultSentimentPeriod);

  const handlePeriodChange = (value) => {
    setActivePeriod(value);
  };

  return (
    <div className={Styles['sectors-type']}>
      <div className={Styles['sectors-type-header']}>
        <div className={Styles['sectors-type-header-title']}>
          Sectors
        </div>
        <DcscPoweredByWithTooltip className={Styles.dcsc} />
        <PeriodFilters className={Styles.filters} onFilterChange={handlePeriodChange} />
      </div>
      <div className={Styles['sectors-type-tags']}>
        <SentimentTags
          isSectors
          entityType="SectorLevel4"
          activePeriod={activePeriod}
        />
      </div>
      <div className={Styles['sectors-type-works']}>
        <div className={Styles['sectors-type-works-title']}>
          How Sentiment Analysis Works
        </div>
        <div className={Styles['sectors-type-works-desc']}>
          Sentiment scores are calculated for each individual piece of content then properly
          weighted and aggregated into topics, companies, sectors, and more.
          {' '}
          <a href="/features/sentiment">
            Learn more.
          </a>
        </div>
        <div className={Styles['sectors-type-works-flow']}>
          <img src={SentimentWorkFlow} alt="" />
        </div>
        <div className={Styles['sectors-type-works-btn']}>
          <a
            href="/features/sentiment#contact-us"
            className={Styles.button}
          >
            Contact Us
          </a>
        </div>
        <div className={Styles['sectors-type-works-link']}>
          <a
            href="/products/api/financial-news/pricing-api/commercial"
          >
            Get the raw data via API
          </a>
        </div>
      </div>
    </div>
  );
};

export default SectorsType;
